export const riskForm = {
  questionsPhase1: [
    {
      pregunta: "inspections.equipmentLocation",
      key: "risk_location",
      responses: [
        { response: "inspections.outdoorOrEncapsulated", score: 0 },
        { response: "inspections.occasionallyAccessible", score: 2 },
        { response: "inspections.largeAndWellVentilated", score: 3 },
        { response: "inspections.between2501000", score: 7 },
        { response: "inspections.lessThan250", score: 17 },
      ],
      response: "",
      score: 0,
    },
    {
      pregunta: "inspections.extentQuantity",
      key: "risk_quantity",
      responses: [
        { response: "inspections.smallQuantities", score: 0 },
        { response: "inspections.lessThan10", score: 3 },
        { response: "inspections.between1150", score: 7 },
        { response: "inspections.moreThan51", score: 10 },
      ],
      response: "",
      score: 0,
    },
    {
      pregunta: "inspections.accessibility",
      key: "risk_accessibility",
      responses: [
        { response: "inspections.inaccessible", score: 0 },
        { response: "inspections.difficultyAccessible", score: 2 },
        { response: "inspections.easyAccessible", score: 5 },
        { response: "inspections.highAccessible", score: 10 },
      ],
      response: "",
      score: 0,
    },
    {
      pregunta: "inspections.potentiallyExposed",
      key: "risk_number_exposed",
      responses: [
        { response: "inspections.none", score: 0 },
        { response: "inspections.between13", score: 2 },
        { response: "inspections.between410", score: 5 },
        { response: "inspections.moreThan10", score: 10 },
      ],
      response: "",
      score: 0,
    },
    {
      pregunta: "inspections.technicalAccessibility",
      key: "risk_technical_accesibility",
      responses: [
        { response: "inspections.never", score: 0 },
        { response: "inspections.occasionally", score: 0 },
        { response: "inspections.frequent", score: 0 },
      ],
      response: "",
      score: 0,
    },
  ],
  questionsPhase2: [
    {
      pregunta: "inspections.materialStatus",
      key: "risk_material_status",
      responses: [
        { response: "inspections.noDamage", score: 5 },
        { response: "inspections.littleDamage", score: 15 },
        { response: "inspections.mediumDamage", score: 25 },
        { response: "inspections.greatDamage", score: 35 },
      ],
      response: "",
      score: 0,
    },
    {
      pregunta: "inspections.asbestosVariety",
      key: "risk_variery",
      responses: [
        { response: "inspections.onlyChrysotile", score: 3 },
        { response: "inspections.amphibolesPresence", score: 5 },
      ],
      response: "",
      score: 0,
    },
  ],
  questionsPhase3: [
    {
      pregunta: "inspections.friability",
      key: "risk_fiability",
      responses: [
        { response: "inspections.noFriability", score: 0.1 },
        { response: "inspections.lowFriability", score: 0.5 },
        { response: "inspections.mediumFriability", score: 0.75 },
        { response: "inspections.highFriability", score: 1 },
      ],
      response: "",
      score: 0,
    },
  ],
};
